module.exports = __webpack_public_path__ + "img/regular_lease_process05.7d7af10c.png";